__turbopack_context__.v({
  "amount": "SearchResultPrice-module-scss-module__h7sida__amount",
  "amounts": "SearchResultPrice-module-scss-module__h7sida__amounts",
  "old-price": "SearchResultPrice-module-scss-module__h7sida__old-price",
  "price": "SearchResultPrice-module-scss-module__h7sida__price",
});
